module.exports = "<slot _v-41b125b1=\"\"></slot>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-41b125b1&file=TabGroup.vue!./~/vue-loader/lib/selector.js?type=template&index=0!./src/TabGroup.vue
// module id = 209
// module chunks = 0